import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { StyledLeadsPageIconWrapper } from "app/pages/sales-intelligence/common-components/layout/leads-styles";
import { getListIcon } from "app/pages/sales-intelligence/sub-modules/opportunities/configuration/lists";
import type { OpportunityListOption } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import { StyledLeadsPageTitle } from "./styles";

type Props = {
    list: Readonly<OpportunityListOption>;
    listTitle?: string;
    listTag?: ReactElement;
    listInfo?: ReactElement;
};

const PageTitle = ({ list, listTitle, listTag, listInfo }: Props): ReactElement => {
    return (
        <>
            <StyledLeadsPageIconWrapper>
                <SWReactIcons
                    iconName={getListIcon(list)}
                    iconColor={colorsPalettes.carbon[400]}
                    size="xs"
                />
            </StyledLeadsPageIconWrapper>

            <Stack
                flex={1}
                minWidth={0}
                overflow="hidden"
                margin="0 16px 0 0"
            >
                <Flex
                    gap="4px"
                    alignItems="center"
                >
                    <StyledLeadsPageTitle>
                        <TruncatedTextWithTooltip fontVariant="h5">{listTitle ?? list.name}</TruncatedTextWithTooltip>
                    </StyledLeadsPageTitle>
                    {listTag}
                </Flex>

                {listInfo}
            </Stack>
        </>
    );
};

export default PageTitle;
